<template>
	<div id="newQianniuExam">
		<template v-if="!isHaveBadge">
			<p align="center">您还没有获得在线上岗徽章！</p>
		</template>
		<template v-else>
			<div class="el-tabs el-tabs--left">
				<div class="el-tabs__header is-left">
					<div class="el-tabs__nav-wrap is-left">
						<div class="el-tabs__nav-scroll">
							<div class="el-tabs__nav is-left">
								<div class="el-tabs__active-bar is-left" style="height: 50px; transform: translateY(0px);"></div>
								<div id="tab-first" class="el-tabs__item js-tab is-left is-active">
									<div class="tab-slot">
										<p class="title">1、登录千牛工作台</p>
									</div>
								</div>
								<div id="tab-second" class="el-tabs__item js-tab is-left">
									<div class="tab-slot">
										<p class="title">2、切换状态</p>
									</div>
								</div>
								<div id="tab-third" class="el-tabs__item js-tab is-left">
									<div class="tab-slot">
										<p class="title">3、快捷短语导入导出</p>
									</div>
								</div>
								<div id="tab-four" class="el-tabs__item js-tab is-left">
									<div class="tab-slot">
										<p class="title">4、快捷短语+开头语</p>
									</div>
								</div>
								<div id="tab-five" class="el-tabs__item js-tab is-left">
									<div class="tab-slot">
										<p class="title">5、转接功能</p>
									</div>
								</div>
								<div id="tab-six" class="el-tabs__item js-tab is-left">
									<div class="tab-slot">
										<p class="title">6、备注</p>
									</div>
								</div>
								<div id="tab-seven" class="el-tabs__item js-tab is-left">
									<div class="tab-slot">
										<p class="title">7、结束语+快捷短语</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="el-tabs__content">
					<div id="tab-first-content" class="el-tab-pane">
						<div id="stoptip-first" class="stoptip">
							<div class="tip">
								<span class="el-icon-success"></span>
								<p>
									<a class="startstudy" @click="startStudy">开始实操练习</a>
								</p>
							</div>
						</div>
						<div id="content-first" class="content">
							<div class="con-left">
								<!--双击图标-->
								<div v-show="isShowQnIcon" class="qnbox">
									<img class="qnbg" src="@/assets/images/doubleQianNiu/qnbg.jpg" />
									<img class="qnicon01" src="@/assets/images/doubleQianNiu/qnicon01.png" @click="showLoginImg" />
								</div>
								<div v-show="isShowQnIcon2" class="qnbox">
									<img class="qnbg" src="@/assets/images/doubleQianNiu/qnbg.jpg" />
									<img class="qnicon02" src="@/assets/images/doubleQianNiu/qnicon02.png" @dblclick="showLoginImg2" />
								</div>
								<!--登录-->
								<div v-show="isShowLoginImg" class="login">
						      <img src="@/assets/images/doubleQianNiu/login.jpg" class="homeImg">
						      <input type="text" v-model="name" class="name" placeholder="请输入账号" />
						      <input type="password" v-model="password" autocomplete="new-password" class="password" placeholder="请输入密码" />
						      <div class="logIn" @click="loginIn"></div>
						    </div>
								<!--获取随机码-->
								<div v-show="isShowRnd" class="loginrnd">
									<img src="@/assets/images/doubleQianNiu/loginrnd.jpg" class="rndImg">
						      <input type="text" v-model="rnd" class="rnd" placeholder="请输入短信验证码" />
						      <div class="logInRnd" @click="loginInRnd"></div>
								</div>
								<!--登录成功点击会话图标-->
								<div v-show="isShowLoginIndex" class="jdbox">
									<img class="jdimg" src="@/assets/images/doubleQianNiu/jdicon.jpg" />
								</div>
							</div>
							<div class="con-right">
								<h3>
									<span class="line"></span>
									提示
								</h3>
								<!--双击图标-->
								<p v-if="isShowQnIcon || isShowQnIcon2">请点击<span style="color: red;font-weight:bold;">左侧练习场</span>中的千牛图标进行登录</p>
								<!--登录-->
								<template v-if="isShowLoginImg || isShowRnd || isShowLoginIndex">
									<p>① 账号密码由项目主管提供</p>
									<p>② 验证码15分钟内有效</p>
									<p>③ 如果是新账号，需要绑定自己的信息</p>
								</template>
							</div>
						</div>
						<div id="studytip-first" class="stoptip">
							<div class="tip">
								<span class="el-icon-success"></span>
								<p>实操通关，进入下一关吧</p>
								<p>
									<a class="startstudy" @click="studyNext('#tab-second', 2, 'second')">GO，下一关</a>
								</p>
							</div>
						</div>
					</div>
					<div id="tab-second-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'second'}">
						<div id="stoptip-second" class="stoptip">
							<div class="tip">
								<span class="el-icon-success"></span>
								<p>
									<a class="startstudy" @click="startStudy">开始实操练习</a>
								</p>
							</div>
						</div>
						<div id="content-second" class="content">
							<div class="con-left">
								<!--挂起-->
								<div v-show="!isShowWgq" class="gqbox">
									<img class="gqimg" src="@/assets/images/doubleQianNiu/gq.jpg" />
									<div class="gqbtn" @click="showGqImg = true"></div>
									<img v-show="showGqImg" class="qhimg" src="@/assets/images/doubleQianNiu/qh.png" />
									<div v-show="showGqImg" class="gqclick" @click="showWgqImg" />
								</div>
								<!-- 未挂起 -->
								<div class="wgqbox">
									<img v-show="isShowWgq" class="wgqimg" src="@/assets/images/doubleQianNiu/wgq.jpg" />
								</div>
							</div>
							<div class="con-right">
								<h3>
									<span class="line"></span>
									提示
								</h3>
								<p>① 挂起=不接待客户，不能随意挂起！！！</p>
								<p>② 下班时间到点后，才能挂起，挂起之后需接待完手上的客户</p>
							</div>
						</div>
						<div id="studytip-second" class="stoptip">
							<div class="tip">
								<span class="el-icon-success"></span>
								<p>实操通关，进入下一关吧</p>
								<p>
									<a class="startstudy" @click="studyNext('#tab-third', 3, 'third')">GO，下一关</a>
								</p>
							</div>
						</div>
					</div>
					<div id="tab-third-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'third'}">
						<div id="stoptip-third" class="stoptip">
							<div class="tip">
								<span class="el-icon-success"></span>
								<p>
									<a class="startstudy" @click="startStudy">开始实操练习</a>
								</p>
							</div>
						</div>
						<div id="content-third" class="content">
							<div class="con-left">
								<div class="kjdybox">
									<!-- 导入 -->
									<div class="kjdy" v-if="isShowKjdy01">
										<img src="@/assets/images/doubleQianNiu/kjdy01.jpg" />
										<div class="kjdy04icon" @click="showKjdy01"></div>
									</div>
									<div class="kjdy" v-if="isShowKjdy02">
										<img src="@/assets/images/doubleQianNiu/kjdy02.jpg" />
										<div class="kjdy06icon">
											<input type="file" @change="tirggerFile($event)" class="btn-file" />
										</div>
									</div>
									<div class="kjdy" v-if="isShowKjdy03">
										<img src="@/assets/images/doubleQianNiu/kjdy03.jpg" />
										<div class="kjdy07icon" @click="showKjdy02"></div>
									</div>
									<!-- 导出 -->
									<div class="kjdy" v-if="isShowKjdy04">
										<img src="@/assets/images/doubleQianNiu/kjdy04.jpg" />
										<div class="kjdy08icon" @click="showKjdy03"></div>
									</div>
								</div>
							</div>
							<div class="con-right">
								<h3>
									<span class="line"></span>
									提示
								</h3>
								<div v-if="isShowKjdyTip01">
									<p>请将快捷短语导入。</p>
								</div>
								<div v-if="isShowKjdyTip02">
									<p>请将快捷短语导出。</p>
								</div>
							</div>
						</div>
						<div id="studytip-third" class="stoptip">
							<div class="tip">
								<span class="el-icon-success"></span>
								<p>实操通关，进入下一关吧</p>
								<p>
									<a class="startstudy" @click="studyNext('#tab-four', 4, 'four')">GO，下一关</a>
								</p>
							</div>
						</div>
					</div>
					<div id="tab-four-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'four'}">
						<div id="stoptip-four" class="stoptip">
							<div class="tip">
								<span class="el-icon-success"></span>
								<p>
									<a class="startstudy" @click="startStudy">开始实操练习</a>
								</p>
							</div>
						</div>
						<div id="content-four" class="content">
							<div class="con-left">
								<div class="kjdybox">
									<!-- 快捷短语 -->
									<div class="kjdy" v-if="isShowKjdy05">
										<img src="@/assets/images/doubleQianNiu/kjdy05.jpg" />
										<div class="kjdy09icon" @click="showKjdy04"></div>
									</div>
									<div class="kjdy" v-if="isShowKjdy06">
										<img src="@/assets/images/doubleQianNiu/kjdy06.jpg" />
										<input type="text" class="kjdy09input" v-focus="true" @keyup.enter="showKjdy05">
										<div class="kjdy03icon" @click="showKjdy05"></div>
									</div>
									<div class="kjdy" v-if="isShowKjdy07">
										<img src="@/assets/images/doubleQianNiu/kjdy07.jpg" />
									</div>
									<!-- 手动回复 -->
									<div class="kjdy" v-if="isShowKjdy08">
										<img src="@/assets/images/doubleQianNiu/kjdy08.jpg" />
										<el-input type="textarea" v-model="kjdy" class="kjdytextarea"></el-input>
										<div class="kjdy03icon" @click="showKjdy06"></div>
									</div>
									<div class="kjdy" v-if="isShowKjdy09">
										<img src="@/assets/images/doubleQianNiu/kjdy09.jpg" />
									</div>
								</div>
							</div>
							<div class="con-right">
								<h3>
									<span class="line"></span>
									提示
								</h3>
								<div v-if="isShowKjdyTip03">
									<p>使用快捷短语回复</p>
									<p>每个店铺对于响应时间的要求不同，首响一般是15秒，平响30秒，越短越好哦</p>
								</div>
								<div v-if="isShowKjdyTip04">
									<p>请手动回复“您好，请问您的收货地址是哪里？”</p>
								</div>
							</div>
						</div>
						<div id="studytip-four" class="stoptip">
							<div class="tip">
								<span class="el-icon-success"></span>
								<p>实操通关，进入下一关吧</p>
								<p>
									<a class="startstudy" @click="studyNext('#tab-five', 5, 'five')">GO，下一关</a>
								</p>
							</div>
						</div>
					</div>
					<div id="tab-five-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'five'}">
						<div id="stoptip-five" class="stoptip">
		          <div class="tip">
		            <span class="el-icon-success"></span>
		            <p>
		              <a class="startstudy" @click="startStudy">开始实操练习</a>
		            </p>
		          </div>
		        </div>
		        <div id="content-five" class="content">
		          <div class="con-left">
		            <div class="zjgnbox">								
									<div class="zjgn" v-show="isShowZjgnicon">
		                <img src="@/assets/images/doubleQianNiu/zjgn.jpg" />
		                <el-input type="textarea" v-model="zjcz" class="zjgntextarea"></el-input>
		                <div class="zjgnsend" @click="showZjgn01"></div>
		            	</div>
		              <div class="zjgn" v-show="isShowZjgn01">
		                <img src="@/assets/images/doubleQianNiu/zjgn01.jpg" />
		                <div class="zjgnicon" @click="showZjgn02"></div>
		            	</div>
		            	<div class="zjgn" v-show="isShowZjgn02">
		                <img src="@/assets/images/doubleQianNiu/zjgn02.jpg" />
		                <div class="zjgn01icon" @mouseover="showZjgn03"></div>
		              </div>
		              <div class="zjgn" v-show="isShowZjgn03">
		                <img src="@/assets/images/doubleQianNiu/zjgn03.jpg" />
		                <div class="zjgn03icon" @mouseover="showZjgn04"></div>
		              </div>
		              <div class="zjgn" v-show="isShowZjgn04">
		                <img src="@/assets/images/doubleQianNiu/zjgn04.jpg" />
		                <div class="zjgn04icon" @click="showZjgn05"></div>
		              </div>
		              <div class="zjgn" v-show="isShowZjgn05">
		                <img src="@/assets/images/doubleQianNiu/zjgn05.jpg" />
		              </div>
		            </div>
		          </div>
		          <div class="con-right">
		            <h3>
		              <span class="line"></span>
		              提示
		            </h3>
		            <p v-if="isShowZjgnTip01">手动回复“抱歉给您带来了不好的体验，这边给您转接售后客服”</p>
		            <p v-if="isShowZjgnTip02">转接功能操作练习：请将“客户002”转接给“小红（贝拉）”</p>
		          </div>
		      	</div>
		        <div id="studytip-five" class="stoptip">
		          <div class="tip">
		            <span class="el-icon-success"></span>
		            <p>实操通关，进入下一关吧</p>
		            <p>
		              <a class="startstudy" @click="studyNext('#tab-six', 6, 'six')">GO，下一关</a>
		            </p>
		          </div>
		        </div>
					</div>
					<div id="tab-six-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'six'}">
						<div id="stoptip-six" class="stoptip">
		          <div class="tip">
		            <span class="el-icon-success"></span>
		            <p>
		              <a class="startstudy" @click="startStudy">开始实操练习</a>
		            </p>
		          </div>
		        </div>
		        <div id="content-six" class="content">
		          <div class="con-left">
		            <div class="ddcjbox">
		              <div class="ddcj" v-if="isShowDdcjicon">
		                <img src="@/assets/images/doubleQianNiu/ddcj.jpg" />
		                <div class="ddcjicon" @click="showDdcj01"></div>
		              </div>
		              <div class="ddcj" v-if="isShowDdcj01">
		                <img src="@/assets/images/doubleQianNiu/ddcj01.jpg" />
		                <el-input class="ddcj01input" type="textarea" v-model="ddcjbz" placeholder="请填写备注"></el-input>
		                <div class="ddcj01icon" @click="showDdcj02"></div>
		              </div>
		              <div class="ddcj" v-if="isShowDdcj02">
		                <img src="@/assets/images/doubleQianNiu/ddcj02.jpg" />
		              </div>
		            </div>
		        	</div>
		        	<div class="con-right">
		            <h3>
		              <span class="line"></span>
		              提示
		            </h3>
		            <p>添加备注</p>
		        	</div>
		    		</div>
		        <div id="studytip-six" class="stoptip">
		          <div class="tip">
		            <span class="el-icon-success"></span>
		            <p>实操通关，进入下一关吧</p>
		            <p>
		              <a class="startstudy" @click="studyNext('#tab-seven', 7, 'seven')">GO，下一关</a>
		            </p>
		          </div>
		        </div>
					</div>
					<div id="tab-seven-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'seven'}">
						<div id="stoptip-seven" class="stoptip">
		          <div class="tip">
		            <span class="el-icon-success"></span>
		            <p>
		              <a class="startstudy" @click="startStudy">开始实操练习</a>
		            </p>
		          </div>
		        </div>
		        <div id="content-seven" class="content">
		          <div class="con-left">
		            <div class="kjdybox">
									<div class="kjdy" v-if="isShowEnd01">
										<img src="@/assets/images/doubleQianNiu/end01.jpg" />
										<el-input type="textarea" v-model="end" class="kjdytextarea"></el-input>
										<div class="kjdy03icon" @click="showEnd01"></div>
									</div>
									<div class="kjdy" v-if="isShowEnd02">
										<img src="@/assets/images/doubleQianNiu/end02.jpg" />
										<div class="kjdy10icon" @click="showEnd02"></div>
									</div>
									<div class="kjdy" v-if="isShowEnd03">
										<img src="@/assets/images/doubleQianNiu/end03.jpg" />
										<input type="text" class="kjdy09input" v-focus="true" @keyup.enter="showEnd03">
										<div class="kjdy03icon" @click="showEnd03"></div>
									</div>
									<div class="kjdy" v-if="isShowEnd04">
										<img src="@/assets/images/doubleQianNiu/end04.jpg" />
									</div>
		            </div>
		          </div>
		          <div class="con-right">
		            <h3>
		              <span class="line"></span>
		              提示
		            </h3>
		            <p>① 结束语是必须要有的哦！</p>
		            <p>② 聊天记录的最后一句一定是要客服回复的！</p>
		            <p>③ 另外还要关注问答比，问答比是客户跟客服的对话各占的比率！</p>
		            <p>如果话术过长，可以适当拆分进行发送</p>
		            <p>不能为了问答比拆封一整句话，形成一句不完整的话</p>
		            <p>只要是能够逻辑清晰，正常表达的，就可以适当的拆分</p>
		            <p>stepA、提示：手动回复“还有其他的可以帮您吗？”</p>
		            <p>stepB、提示：发送快捷短语。好的亲，祝您购物愉快，有其他问题可以咨询我哦~小金随时为您服务！</p>
		          </div>
		        </div>
		        <div id="studytip-seven" class="stoptip">
		          <div class="tip" style="width: 400px;height: 310px;">
		            <span class="el-icon-success"></span>
		            <p style="padding-bottom: 5px;">{{ tjkName }}（{{ tjkNumber }}），恭喜您！</p>
		            <p style="padding: 5px 0;">通过【双11&618徽章】培训-实操演练！</p>
		            <p style="padding: 5px 0;">快快截图此页面去提交作业吧！</p>
		            <p style="padding: 5px 0;">如果想再次练习可以点击再来一遍！</p>
		            <p style="padding-top: 5px;"><el-button type="primary" @click="again">再来一遍</el-button></p>
		          </div>
		        </div>
					</div>
				</div>
			</div>
		</template>
	 </div>
</template>

<script>
export default {
  data() {
    return {
    	tabCurrent: 'first',
    	badgesList: [],
    	isHaveBadge: true, //是否有在线上岗徽章,去掉门槛，默认为true
    	tjkName: '',
    	tjkNumber: '',
    	//第1步
    	isShowQnIcon: true, //是否显示千牛图标
    	isShowQnIcon2: false, //显示点击千牛图标后图片
      isShowLoginImg: false, //是否显示登录图片
      name: '', //登录账号
     	password: '', //密码
     	showPassword: false, //显示账号密码
     	isShowRnd: false, //显示获取随机码
     	rnd: '', //随机密码
     	showRnd: false, //显示随机码
     	isShowLoginIndex: false, //显示登录后图片
     	//第2步
     	showGqImg: false, //显示切换挂起图片
     	isShowWgq: false, //显示未挂起图片
     	//第3步
     	isShowKjdy01: true,
     	isShowKjdy02: false,
     	isShowKjdy03: false,
     	isShowKjdy04: false,
     	isShowKjdyTip01: true,
     	isShowKjdyTip02: false,
     	//第4步
     	kjdy: '',
     	isShowKjdy05: true,
     	isShowKjdy06: false,
     	isShowKjdy07: false,
     	isShowKjdy08: false,
     	isShowKjdy09: false,
     	isShowKjdyTip03: true,
     	isShowKjdyTip04: false,
      //第5步
      zjcz: '',
     	isShowZjgnicon: true,
     	isShowZjgn01: false,
     	isShowZjgn02: false,
     	isShowZjgn03: false,
     	isShowZjgn04: false,
     	isShowZjgn05: false,
      isShowZjgnTip01: true,
      isShowZjgnTip02: false,
      //第6步
     	isShowDdcjicon: true,
     	isShowDdcj01: false,
     	isShowDdcj02: false,
      ddcjbz: '',
      //第7步
     	end: '',
     	isShowEnd01: true,
     	isShowEnd02: false,
			isShowEnd03: false,
			isShowEnd04: false,
    }
  },
  mounted() {
  	$('#stoptip-'+this.tabCurrent).show();
  	this.initAll();
  	this.getMyBadges();
  },
  watch: {

  },
  directives: {
    focus: {
      inserted: function(el, {value}) {
        if(value){
          el.focus();
        }
      }
    }
  },
  methods: {
  	formatDate: function (value) {
	    let date = new Date(value);
	    let y = date.getFullYear();
	    let MM = date.getMonth() + 1;
	    MM = MM < 10 ? ('0' + MM) : MM;
	    let d = date.getDate();
	    d = d < 10 ? ('0' + d) : d;
	    let h = date.getHours();
	    h = h < 10 ? ('0' + h) : h;
	    let m = date.getMinutes();
	    m = m < 10 ? ('0' + m) : m;
	    let s = date.getSeconds();
	    s = s < 10 ? ('0' + s) : s;
	    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
	  },
	  //查询当前用户徽章
	  getMyBadges() {
	  	this.$http.post(API_ROOT.college + '/user/getByToken').then(response => {
        var result = response.data;
        if(result.success) {
        	if(result.data) {
                this.tjkName = result.data.realName;
                this.tjkNumber = result.data.tjkNumber;
        	}
        }else {
          this.$alert(result.msg);
        }
      }, response => {
        this.$alert('Ajax请求接口抛异常！')
      })
	  },
	  //初始化第1步状态值
    initFirst() {
    	this.name = ''
    	this.password = ''
    	this.rnd = ''
    	this.isShowQnIcon = true
    	this.isShowQnIcon2 = false
    	this.isShowLoginImg = false
    	this.showPassword = false
    	this.isShowRnd = false
    	this.showRnd = false
    	this.isShowLoginIndex = false
    	this.isShowLoginIndexTwo = false
    },
    //初始化第2步状态值
    initSecond() {
    	this.showGqImg = false
     	this.isShowWgq = false
    },
    //初始化第3步状态值
    initThird() {
     	this.isShowKjdy01 = true;
     	this.isShowKjdy02 = false;
     	this.isShowKjdy03 = false;
     	this.isShowKjdy04 = false;
     	this.isShowKjdyTip01 = true;
     	this.isShowKjdyTip02 = false;
    },
    //初始化第4步状态值
    initFour() {
    	this.isShowKjdy05 = true;
     	this.isShowKjdy06 = false;
     	this.isShowKjdy07 = false;
     	this.isShowKjdy08 = false;
     	this.isShowKjdyTip03 = true;
     	this.isShowKjdyTip04 = false;
    },
    //初始化第5步状态值
    initFive() {
     	this.isShowZjgnicon = true;
     	this.isShowZjgn01 = false;
     	this.isShowZjgn02 = false;
     	this.isShowZjgn03 = false;
     	this.isShowZjgn04 = false;
     	this.isShowZjgn05 = false;
    },
    //初始化第6步状态值
    initSix() {
     	this.isShowDdcjicon = true;
     	this.isShowDdcj01 = false;
     	this.isShowDdcj02 = false;
      this.ddcjbz = '';
    },
    //初始化第7步状态值
    initSeven() {
    	this.end = '';
     	this.isShowEnd01 = true;
     	this.isShowEnd02 = false;
			this.isShowEnd03 = false;
			this.isShowEnd04 = false;
    },
  	//初始化所有tab内容
  	initAll() {
    	//第1步
    	this.initFirst();
     	//第2步
     	this.initSecond();
     	//第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步
      this.initSeven()
  	},
    //开始实操练习
    startStudy() {
    	$('#stoptip-'+this.tabCurrent).hide();
    	$('#content-'+this.tabCurrent).show();
    },
    //下一关
    studyNext(next, index, tabCurrent) {
    	$('.el-tabs__header').find('.js-tab').each(function() {
    		$(this).removeClass('is-active');
    	});
    	$(next).addClass('is-active');
    	$('.el-tabs__content').find('.el-tab-pane').each(function() {
    		$(this).hide();
    	});
    	$(next+'-content').show();
    	this.tabCurrent = tabCurrent;
    },
    //第1步-单击千牛图标
    showLoginImg() {
    	this.isShowQnIcon = false;
    	this.isShowQnIcon2 = true;
    },
    //双击千牛图标
    showLoginImg2() {
    	this.isShowQnIcon2 = false;
    	this.isShowLoginImg = true;
    },
    //登录
    loginIn() {
      if(this.name == '') {
        this.notify('<p>请输入账号</p>');
        return;
      }else if(this.name != 'taojin:111') {
        this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>');
        return;
      }
      if(this.password == '') {
        this.notify('<p>请输入密码</p>');
        return;
      }else if(this.password != '123456') {
        this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>');
        return;
      }
      this.isShowLoginImg = false;
      this.isShowRnd = true;
    },
    //验证码登录
    loginInRnd() {
    	let self = this;
    	if(this.rnd == '') {
        this.notify('<p>请输入短信验证码</p>');
        return;
      }else if(this.rnd != '789654') {
        this.notify('<p>短信验证码错误</p>');
        return;
      }
      this.isShowRnd = false;
      this.isShowLoginIndex = true;
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 1500);
    },
    //第2步-切换状态-显示未挂起图片
    showWgqImg() {
    	var self = this
    	this.showGqImg = false
    	this.isShowWgq = true
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 1500);
    },
    //第3步-快捷短语
    showKjdy01() {
    	this.isShowKjdy01 = false;
    	this.isShowKjdy02 = true;
    },
    tirggerFile($event) {
    	let self = this;
      var file = $event.target.files;
    	setTimeout(function() {
        self.isShowKjdy02 = false;
        self.isShowKjdy03 = true;
      }, 500);
    },
    showKjdy02() {
    	let self = this;
    	this.isShowKjdy03 = false;
    	this.isShowKjdy04 = true;
    	this.isShowKjdyTip01 = false;
    	this.isShowKjdyTip02 = true;
    },
    //导出
    showKjdy03() {
    	let self = this;
    	window.open('http://taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv');
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 1500);
    },
    //快捷短语
    showKjdy04() {
    	this.isShowKjdy05 = false;
    	this.isShowKjdy06 = true;
    },
    //手动回复
    showKjdy05() {
    	let self = this;
    	this.isShowKjdy06 = false;
    	this.isShowKjdy07 = true;
    	this.notify('<p>快捷短语回复练习完成，下一步手打文字回复</p>')
    	setTimeout(function() {
        self.isShowKjdyTip03 = false;
        self.isShowKjdyTip04 = true;
        self.isShowKjdy07 = false;
        self.isShowKjdy08 = true;
      }, 1500);
    },
    showKjdy06() {
    	let self = this;
    	if(this.kjdy.indexOf('您好')<0 || this.kjdy.indexOf('请问您的收货地址是哪里？')<0) {
        this.notify('<p>请输入正确的回复内容</p>')
        return false;
      }
    	this.isShowKjdy08 = false;
    	this.isShowKjdy09 = true;
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 1500);
    },
    //第5步-转接功能
    showZjgn01() {
    	if(this.zjcz.indexOf('抱歉给您带来了不好的体验')<0 || this.zjcz.indexOf('这边给您转接售后客服')<0) {
        this.notify('<p>请输入正确的回复内容</p>')
        return false;
      }
    	this.isShowZjgnicon = false;
    	this.isShowZjgn01 = true;
    	this.isShowZjgnTip01 = false;
    	this.isShowZjgnTip02 = true;
    },
    showZjgn02() {
    	this.isShowZjgn01 = false;
      this.isShowZjgn02 = true;
    },
    showZjgn03() {
    	this.isShowZjgn02 = false;
      this.isShowZjgn03 = true;
    },
    showZjgn04() {
    	this.isShowZjgn03 = false;
      this.isShowZjgn04 = true;
    },
    showZjgn05() {
    	this.isShowZjgn04 = false;
      this.isShowZjgn05 = true;
      let self = this;
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 1500);
    },
    //第6步-备注
    showDdcj01() {
    	this.isShowDdcjicon = false;
    	this.isShowDdcj01 = true;
    },
    showDdcj02() {
      if(this.ddcjbz != '发粉色') {
        this.notify('<p>请填写正确的订单备注</p>');
        return;
      }
    	this.isShowDdcj01 = false;
      this.isShowDdcj02 = true;
      let self = this;
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 1500);
    },
    //第7步-结束
    showEnd01() {
    	this.isShowEnd01 = false;
    	this.isShowEnd02 = true;
    },
    showEnd02() {
    	this.isShowEnd02 = false;
    	this.isShowEnd03 = true;
    },
    showEnd03() {
    	this.isShowEnd03 = false;
    	this.isShowEnd04 = true;
    	let self = this;
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 1500);
    },
    again() {
    	window.location.reload();
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString (date, format) { // 时间格式化
      var date = new Date(date),
        o = {
          "M+" : date.getMonth() + 1,
          "d+" : date.getDate(),
          "h+" : date.getHours(),
          "m+" : date.getMinutes(),
          "s+" : date.getSeconds(),
          "q+" : Math.floor((date.getMonth() + 3) / 3),
          "S" : date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday(n){
      let lastDays = new Date().setDate((new Date().getDate() - n));
      let lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    }
  } 
}
</script>
<style lang="less" scoped>
.account-table {
  border-top: 1px solid #000000;
  border-left: 1px solid #000000;
  margin: 10px;
  border-spacing: inherit;
  > tr > td {
    border-right: 1px solid #000000;
    border-bottom: 1px solid #000000;
    padding: 5px;
  }
}
.mynone {
    display: none !important;
}
</style>


// WEBPACK FOOTER //
// ./src/page/simulate/doubleQianNiuExam.vue